module.exports = __webpack_public_path__ + "img/11.1eb85c35.png";